import React from "react";

// User-uploaded heart-with-infinity-loop mark, white background removed, served from /public/media.
// `variant`:
//   - "stacked" / "mark" → heart PNG
//   - "wordmark" → block sans wordmark fallback
export default function Logo({ size = 72, variant = "stacked", className = "" }) {
    if (variant === "wordmark") {
        return (
            <span className={`font-display text-burgundy uppercase tracking-tight ${className}`}>
                Ever After
            </span>
        );
    }
    return (
        <img
            src="/media/logo-heart.png"
            alt="Ever After"
            width={size}
            className={`object-contain ${className}`}
            style={{ width: size, height: "auto" }}
            data-testid="ea-logo"
        />
    );
}
